import React, { FC, ReactNode } from 'react';
import { RendererProvider, ThemeProvider } from 'react-fela';
import { createRenderer } from 'fela';
import { theme } from 'styles';

import { applyStaticCSS, applyFonts } from '../utilities';
import * as Config from '../config';

interface FelaProps {
    children?: ReactNode;
}

const Fela: FC<FelaProps> = ({ children }) => {
    const renderer = createRenderer(Config.rendererConfig);

    React.useEffect(() => {
        applyStaticCSS(renderer, Config.staticCSS);
        applyFonts(renderer, Config.fonts);

        return () => {
            renderer.clear();
        };
    }, [renderer]);

    const RendererProviderWithChildren = RendererProvider as React.ComponentType<{ renderer: typeof renderer; children?: ReactNode }>;
    const ThemeProviderWithChildren = ThemeProvider as React.ComponentType<{ theme: typeof theme; children?: ReactNode }>;
    
    return (
        <RendererProviderWithChildren renderer={renderer}>
            <ThemeProviderWithChildren theme={theme}>{children}</ThemeProviderWithChildren>
        </RendererProviderWithChildren>
    );
};

export default Fela;
